import React, { forwardRef } from "react";
import "./NoResultsFound.scss";

export interface NoResultsFoundProps {
    message: string;
    description: string;
    className?: string;
}

export const NoResultsFound = React.memo(forwardRef<HTMLDivElement, NoResultsFoundProps>(({
    message,
    description,
    className = ''
}, ref) => {
    return (
        <div
            ref={ref}
            className={`no-results-container ${className}`}
            role="status"
            aria-live="polite"
            aria-atomic="true"
            tabIndex={-1}
        >
            <h2 className="no-results-header">{message}</h2>
            <p className="no-results-description">{description}</p>
        </div>
    );
}));

NoResultsFound.displayName = 'NoResultsFound';
